export default __webpack_public_path__ + "static/media/o4.63ff6296.png";